import { useEffect, useState } from 'react';
import { useRenderNow } from '@/hooks/useRenderNow';

/**
 * The current time, refreshed every `intervalMs` (countdowns, "live now"
 * labels). Only the component that calls it re-renders on each tick.
 *
 * It starts from the server's render time when hydrating (`useRenderNow`), so
 * a server-rendered countdown hydrates without a mismatch, and moves to the
 * real time right after mount.
 */
export function useNow(intervalMs = 1000): Date {
  const renderNow = useRenderNow();
  const [now, setNow] = useState(renderNow);
  useEffect(() => {
    setNow(new Date());
    const id = window.setInterval(() => setNow(new Date()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}

export default useNow;
